import { useSmartFillBridge } from '../bridge/context';
import { SidebarSessionProvider, useBridgeBootstrap } from '../bridge/session';
import { RetryButton, SidebarState } from '../components/SidebarState';
import { SidebarHistoryProvider } from './history';
import { PasteProvider } from './paste';
import { SidebarShell } from './SidebarShell';

export function SidebarBootstrap() {
  const client = useSmartFillBridge();
  const { state, session, refresh } = useBridgeBootstrap(client);

  if (state.status === 'waiting') {
    return (
      <main className="smartfill-app">
        <SidebarState
          kind="loading"
          title="Waiting for the Cara extension"
          description="The secure Smart Fill bridge is required before this sidebar can load."
        />
      </main>
    );
  }

  if (state.status === 'connecting') {
    return (
      <main className="smartfill-app">
        <SidebarState
          kind="loading"
          title="Connecting to Cara"
          description="Loading your active tab, bucket, and page session."
        />
      </main>
    );
  }

  if (state.status === 'error') {
    const timedOut = state.error.code === 'TIMEOUT';
    const disconnected = state.error.code === 'DISCONNECTED';
    return (
      <main className="smartfill-app">
        <SidebarState
          kind="error"
          title={
            timedOut
              ? 'The extension took too long to respond'
              : disconnected
                ? 'The Cara extension disconnected'
                : 'Smart Fill could not load'
          }
          description={state.error.message}
          action={
            state.error.retryable ? (
              <RetryButton onClick={refresh}>Reconnect</RetryButton>
            ) : undefined
          }
        />
      </main>
    );
  }

  if (!session) return null;

  return (
    <SidebarSessionProvider key={session.accountGeneration} value={session}>
      <SidebarHistoryProvider>
        <PasteProvider>
          <SidebarShell />
        </PasteProvider>
      </SidebarHistoryProvider>
    </SidebarSessionProvider>
  );
}
